﻿import core = require('../core');
import context = require('./context');
import common = require('../common');
import lazzyLoader = require('./lazzyLoader');
import config = require('./config');
import querystringify = require("querystringify");
import HotEditableButtonComponent = require('./vue/hotEditable/HotEditableButtonComponent');
import HotEditableFormManager = require('./vue/hotEditable/HotEditableFormManager');

declare function require(name: string): any;
declare var module: any;
declare var moment: any;

//const jsUtilities = require('../../js/jsUtilities');
const jsClasses = require('../../js/jsClasses');

interface IAlternativeMessage {
    updatedMessage: string;
    updatedMessageTitle: string;
    updatedMessageType: common.MessageTypes;
}

class Utilities {
    /* Utilitaires...

        *********** Dynamic element  ***********

            Noeuds HTML dynamiques dont la visibilité est tributaire de la valeur d'un champs de formulaire.

            Attributs :
            - dynamic-element (required) : identifie un element dynamique
            - dynamic-element--field-target (required) : identifie le selecteur du champ de formulaire dont la visibilité est tributaire
            - dynamic-element--field-value (required) : identifie la valeur que le champ de formulaire doit avoir afin de rendre visible l'element dynamique. Séparer les valeurs par l'opérateur '||' (ou), voir l'exemple ci-dessous.

            Paramêtres d'inititialization :
            - $root (optionel) : Element jquery qui scope l'initialisation (par défaut, sera le 'body')
            - inputEventName (optionel) : nom de l'événement écouté pour mettre à jour l'élément dynamique (par défaut, sera 'change').

            Utilisation :

            <select name="MonChamps">
                <option value="a" selected="selected">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
            </select>
            <p dynamic-element dynamic-element--field-target="[name='MonChamps']" dynamic-element--field-value="b || c">Visible seulement lorsque MonChamps vaut 'b' ou 'c'.</p>

            JS> utilities.initializeDynamicElements();
    */

    static ids = {
        mainBody: 'MainBody'
    };

    static attributes = {
        disabled: 'disabled'
    };

    static keyNames = {
        enter: 'Enter',
        tab: 'Tab',
        escape: [
            'Escape',
            'Esc'
        ]
    };

    static keyCodes = {
        enter: 13,
        tab: 9,
        escape: 27
    };

    //private $ = (window as any).jQuery as JQuery;
    private _body: JQuery = null;

    constructor() {
        lazzyLoader.loadMoment();
    }

    config = { screenBreakPoints: { phone: 640, tablet: 1024 } };

    storage = (context as any).storage;

    /** format options: N */
    emptyGuid(format?: string) {
        return format === 'N'
            ? '00000000000000000000000000000000'
            : '00000000-0000-0000-0000-000000000000';
    }

    printInfo(obj: any) {
        console.log(obj);
        return this;
    }

    printWarn(obj: any) {
        console.log(obj);
        return this;
    }

    printError(obj: any) {
        console.log(obj);
        return this;
    }

    deepPrint(obj: object) {
        if (!obj) {
            this.printError("L'object est null.");
            return;
        }

        for (let k in obj) {
            const x = {};
            x[k] = obj[k];
            this.printInfo(x);
        }
    }
    isCtlKeyPressed(event?: MouseEvent | KeyboardEvent) {
        return event && !!event.ctrlKey;
    }
    isEnterKeyCode(event: KeyboardEvent) {
        return event.key
            ? event.key.toLowerCase() === Utilities.keyNames.enter.toLowerCase()
            : (event as any).keyCode === Utilities.keyCodes.enter;//<- deprecated
    }

    isTabKeyCode(event: KeyboardEvent) {
        return event.key
            ? event.key.toLowerCase() === Utilities.keyNames.tab.toLowerCase()
            : (event as any).keyCode === Utilities.keyCodes.tab;//<- deprecated
    }

    isEscapeKeyCode(event: KeyboardEvent) {
        if (event.key) {
            const k = event.key.toLowerCase();
            return k === Utilities.keyNames.escape[0].toLowerCase() || k === Utilities.keyNames.escape[1].toLowerCase();
        }
        return (event as any).keyCode === Utilities.keyCodes.escape;//<- deprecated
    }

    validation = {
        email(value: string) {
            if (!value || value.length === 0)
                return false;

            const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            return pattern.test(value);
        }
    }

    toPascalCaseProperties(obj: {}) {
        if (obj)
            for (let k in obj) {
                if (obj.hasOwnProperty(k)) {
                    const newK = this.makeFirstCharUpper(k);
                    if (k !== newK) {
                        obj[newK] = obj[k];
                        delete obj[k];
                    }
                }
            }
        return obj;
    }

    convertMessageTypeToHotEditableMessageType(messageType?: common.MessageTypes) {
        if (messageType) {
            if (messageType === common.MessageTypes.info)
                return common.HotEditableMessageTypes.info;
            if (messageType === common.MessageTypes.success)
                return common.HotEditableMessageTypes.success;
            if (messageType === common.MessageTypes.warning)
                return common.HotEditableMessageTypes.warning;
            if (messageType === common.MessageTypes.error)
                return common.HotEditableMessageTypes.error;
        }
        return common.HotEditableMessageTypes.unknown;
    }

    /** Permet d'extraire le type de message alternatif, et corrige le message le cas echeant. 
      * La liste des macros doit correspondre a celle incluse dans le fichier UpaFunctionalException.cs (sub: AltMessageTypes). */
    extractAltMessageFromMacro(message: string, defaultMessageTitle: string, defaultMessageType: string) {
        const macros = {
            info: '[[info]]',
            warning: '[[warning]]',
            error: '[[error]]',
            success: '[[success]]',
            notification: '[[notification]]'
        };
        const m = message.trim().toLowerCase();

        const f = (macro: string, msgTitle: string, msgType: string) => {
            const i = m.indexOf(macro);
            if (i !== 0)
                return null;
            return {
                updatedMessage: message.substring(macro.length),
                updatedMessageTitle: msgTitle,
                updatedMessageType: msgType
            } as IAlternativeMessage;
        };

        const map = [
            [macros.success, config.messages.defaultTitles.success(), common.MessageTypes.success],
            [macros.info, config.messages.defaultTitles.info(), common.MessageTypes.info],
            [macros.warning, config.messages.defaultTitles.warning(), common.MessageTypes.warning],
            [macros.error, config.messages.defaultTitles.error(), common.MessageTypes.error],
            [macros.notification, config.messages.defaultTitles.notification(), common.MessageTypes.notification]
        ];

        for (let i = 0; i < map.length; i++) {
            const r = f(map[i][0], map[i][1], map[i][2]);
            if (r)
                return r;
        }

        return {
            updatedMessage: message,
            updatedMessageTitle: defaultMessageTitle,
            updatedMessageType: defaultMessageType
        } as IAlternativeMessage;
    }

    private _domParser = null as DOMParser;
    private getDomParser() {
        if (!this._domParser)
            this._domParser = new DOMParser();
        return this._domParser;
    }

    /** retournera la valeur retournee par l'execution du script */
    executeFirstScript(html: string, parser?: DOMParser, evalCallback?: (evalReturn: any) => void, finalEvalCallback?: () => void) {
        parser = parser || this.getDomParser();

        const doc = parser.parseFromString(html, "text/html");
        const scripts = doc.getElementsByTagName('script');
        if (scripts.length)
            return this.evalScripts([scripts[0]], evalCallback, finalEvalCallback)[0];
        if (finalEvalCallback)
            finalEvalCallback();
        return null;
    }


    /** retournera un tableau contenant les valeurs retournees par l'execution des scripts */
    executeScripts(html: string, parser?: DOMParser, evalCallback?: (evalReturn: any) => void, finalEvalCallback?: () => void) {
        parser = parser || this.getDomParser();

        const doc = parser.parseFromString(html, "text/html");
        const scripts = doc.getElementsByTagName('script');
        const s = [];
        for (let i = 0; i < scripts.length; i++)
            s.push(scripts[i]);
        return this.evalScripts(s, evalCallback, finalEvalCallback);
    }

    private evalScripts(scripts: HTMLScriptElement[], evalCallback?: (evalReturn: any) => void, finalCallback?: () => void) {
        const res = [];
        for (let i = 0; i < scripts.length; i++) {
            const code = scripts[i].innerHTML.trim();
            if (code) {
                const r = eval(code) || null;
                if (evalCallback)
                    evalCallback(r);
                res.push(r);
            }
        }
        if (finalCallback)
            finalCallback();
        return res;
    }

    ajax = ((mod: any) => {
        mod.call = (requestDefinition: any) => {
            if (requestDefinition.getInitialAction()) requestDefinition.getInitialAction()();

            const request = call(requestDefinition.toAjaxOptions());

            if (requestDefinition.getSuccessAction()) request.done(requestDefinition.getSuccessAction());
            if (requestDefinition.getErrorAction()) request.fail(requestDefinition.getErrorAction());
            if (requestDefinition.getFinalAction()) request.always(requestDefinition.getFinalAction());
        };

        function call(options: any) { return $.ajax(options); }

        return mod;
    })({});

    debug(key: string, obj: any) {
        (w => {
            w.debug = w.debug || {};
            if (w.debug.hasOwnProperty(key)) throw "[ERREUR::utilities.debug()] La clé existe déjà.";
            w.debug[key] = obj;
        })(window as any);
    }

    /// Permet de savoir si un element (el) est a l'exterieur d'un autre (refEl).
    isOutside(el: Element, refEl: Element) {
        if (!el || !refEl) {
            this.printWarn("[utilities::isOutsideElement] ATTENTION: Les propriete 'currentElement' et 'refElement' sont requise.");
            return true;
        }

        do {
            if (el == refEl)// laisser double-egals ici (ne pas mettre tripple-egals)
                return false; // le click est a l'interieur du component courrant
            (el as any) = el.parentNode; // monter d'un niveau
        } while (el);

        return true;
    }

    isInside(el: Element, target: common.IKeyValue, targets?: common.IKeyValue[], _isSubsequent?: boolean) {
        if (!el) throw "La prop 'el' est NULL.";
        if (!target && !targets) throw "La prop 'targets' est requise lorsque 'target' est NULL.";
        if (!_isSubsequent) {
            const testTarget = (t: common.IKeyValue) => t && t.key && el.getAttribute(t.key) === t.value;
            if (testTarget(target))
                return true;
            for (let i = 0; i < targets.length; i++)
                if (testTarget(targets[i]))
                    return true;
        }
        if (el.children)
            for (let i = 0; i < el.children.length; i++)
                if (this.isInside(el.children[i], target, targets, true))
                    return true;
        return false;
    }

    getDimensions($element: JQuery) {
        if (!$element)
            return null;
        const o = $element.offset();
        const r = {
            width: $element.width(),
            height: $element.height(),
            top: o.top,
            left: o.left
        } as common.IDimensions;
        return r;
    }

    escapeSimpleQuote(input: string) {
        const output = input.replace(/'/g, "\\'");
        return output;
    }

    appendValues(values?: object, obj?: object) {
        obj = obj || {};

        if (values)
            for (let k in values)
                if (values.hasOwnProperty(k))
                    obj = this.appendValue(k, values[k], obj);

        return obj;
    }

    appendValue(key: string, value: any, obj?: object) {
        if (!obj) obj = {};

        if (!obj.hasOwnProperty(key) ||
            (
                !obj[key] &&
                obj[key] !== 0 &&
                obj[key] !== false
            ))
            obj[key] = value;

        return obj;
    }

    dequeueWithDelayBetweenItems<TItem>(getter: () => TItem, onDequeue?: (item: TItem) => void, delayMs?: number) {
        const defaultDelayMs = 10;

        if (!getter)
            throw "L'argument 'getter' est requis.";

        const x = getter() || null;

        if (!x)
            return;

        if (onDequeue)
            onDequeue(x);

        const f = () => {
            this.dequeueWithDelayBetweenItems(getter, onDequeue, delayMs);
        };

        setTimeout(f, delayMs || defaultDelayMs);
    }

    errorToString(e: common.IError) {
        if (!e)
            return '';

        var m = (e.message || 'Erreur inconnue').trim();
        if (e.code)
            m += ' ({code})'.replace('{code}', e.code.toString());
        m += '.'
        return m;
    }

    errorsToString(errors?: common.IError[]) {
        var m = '';

        if (!errors)
            return m;

        for (let i = 0; i < errors.length; i++) {
            const e = errors[i];
            const s = this.errorToString(e);
            if (m && s)
                m += ' ';
            m += s;
        }

        return m;
    }

    hasProperty(thing: any, key: string) {
        return (thing as Object).hasOwnProperty(key)
    }

    makeFirstCharLower(text: string) {
        const r = text.charAt(0).toLowerCase() + text.slice(1);
        return r;
    }

    makeFirstCharUpper(text: string) {
        const r = text.charAt(0).toUpperCase() + text.slice(1);
        return r;
    }
    isNullOrWhitespaces(text: string) {
        return !text || text.match(/^ *$/) !== null;
    }
    isEmptyOrWhitespaces(text: string) {
        return text === '' || text.match(/^ *$/) !== null;
    }
    redirectAsMailTo(thisElement: Element, temporaryLinkTarget?: string, thisElementEmailCustomAttribute?: string) {
        temporaryLinkTarget = temporaryLinkTarget || '.fn--mailto';
        const $tempLink = this.getFirstElement(temporaryLinkTarget);
        if (!$tempLink.length) throw "Aucun lien temporaire existe pour la cible '" + temporaryLinkTarget + "'.";
        const element = $tempLink
            .attr('href', 'mailto:' + $(thisElement).attr(thisElementEmailCustomAttribute || 'data-email'))
            .on('click', e => {
                e.stopPropagation();
            })[0];
        element.click();
    }

    currentUrl() {
        return window.location.href.trim();
    }

    /**
     * Utilise lorsqu'employe dans l'attribut HTML "onclick" afin d'offrir le support du Ctl+Click vers un nouvel onglet.
     * Ex.: onclick="main.utilities.redirectOnClick(event, '/mon-url-d-amour')"
     * */
    redirectOnClick(event: MouseEvent, url?: string) {
        const openInBlankPage = this.isCtlKeyPressed(event);
        this.redirect(url, openInBlankPage);
        return this;
    }

    /**
     * Utilise lorsqu'employe dans l'attribut HTML "onclick" afin d'offrir le support du Ctl+Click vers un nouvel onglet.
     * Ex.: onclick="main.utilities.redirectWithDelayOnClick(event, '/mon-url-d-amour', 500)"
     * */
    redirectWithDelayOnClick(event: MouseEvent, url?: string, delay?: number) {
        const openInBlankPage = this.isCtlKeyPressed(event);
        this.redirectWithDelay(url, delay, openInBlankPage);
        return this;
    }

    redirect(url?: string, openInBlankPage?: boolean) {
        //Ajouter delay de 5ms pour IE11
        const delay = this.isIe() ? 5 : 0;

        this.redirectWithDelay(url, delay, openInBlankPage);
        return this;
    }

    refreshWithDelay(delay?: number) {
        return this.redirectWithDelay(null, delay);
    }

    redirectWithDelay(url?: string, delay?: number, openInBlankPage?: boolean) {
        url = url || window.location.href;
        delay = delay || delay === 0 ? delay : 5;
        openInBlankPage = openInBlankPage === true;
        const f = () => {
            if (openInBlankPage) {
                window.open(url, '_blank');
                return;
            }
            //window.location = url as any;//Note: avant Inca
            const i = url.indexOf('#');
            if (i >= 0)
                url = url.substring(0, i);
            window.location.href = url;
        };
        if (delay)
            setTimeout(f, delay);
        else
            f();
        return this;
    }

    refresh() {
        return this.redirect();
    }
    redirectWithOptions(url?: string, options?: common.urlOptions[]) {
        options = options ?? [];
        var openInBlankPage = false;
        for (let i = 0; i < options.length; i++) {
            const o = options[i];
            if (o && o.toLowerCase() === common.urlOptions.targetBlank.toLowerCase())
                openInBlankPage = true;
        }
        this.redirect(url, openInBlankPage);
        return true;
    }
    /** Retournera FALSE si la redirection n'au pas lieu. */
    autoRedirect(responseData: common.IHotEditableFormResponseData, previousPageUrl?: string) { 
        var url = (responseData ?? {}).redirectUrl;
        if (!url)
            return false;
        if (responseData.forceRedirectOnDeleteAction)
            url = previousPageUrl || '/';        
        this.redirectWithOptions(url, responseData.redirectUrlOptions);
        return true;
    }

    isEmptySearchParameter(sp: common.ISearchParameters) {
        return this.isEmptySearchParametersPaging(sp) &&
            this.isEmptySearchParametersTerms(sp) &&
            this.isEmptySearchParametersFilters(sp) &&
            this.isEmptySearchParametersSorters(sp);
    }

    isEmptySearchParametersPaging(sp: common.ISearchParameters) {
        if (!sp)
            return true;

        return !sp.pageNumber && !sp.pageSize;// x == null || x <= 0
    }

    isEmptySearchParametersTerms(sp: common.ISearchParameters) {
        if (!sp)
            return true;

        if (sp.originalTerms)
            return false;

        if (sp.terms)
            for (let i = 0; i < sp.terms.length; i++) {
                const t = sp.terms[i];
                if (t)
                    return false;
            }

        return true;
    }

    isEmptySearchParametersFilters(sp: common.ISearchParameters) {
        if (!sp)
            return true;

        if (sp.filters)
            for (let i = 0; i < sp.filters.length; i++) {
                const f = sp.filters[i];
                if (f.values)
                    for (let j = 0; j < f.values.length; j++)
                        if (f.values[j])
                            return false;
            }

        return true;
    }

    isEmptySearchParametersSorters(sp: common.ISearchParameters) {
        if (!sp)
            return true;

        if (sp.sorters)
            for (let i = 0; i < sp.sorters.length; i++) {
                const s = sp.sorters[i];
                if (s.order && s.order !== common.SortOrderTypes.unset)
                    return false;
            }

        return true;
    }

    /** Deep copy */
    copySearchParameters(sp: common.ISearchParameters) {
        const copy = this.updateSearchParameters(null, sp);
        return copy;
    }

    isSameSearchParameters(sp1: common.ISearchParameters, sp2: common.ISearchParameters) {
        if (!sp1 && !sp2)
            return true;

        if (!sp1 || !sp2)
            return false;

        if ((sp1.pageNumber || 1) !== (sp2.pageNumber || 1))
            return false;

        if ((sp1.pageSize || 1) !== (sp2.pageSize || 1))
            return false;

        // clauses
        // if (sp1.termsClause !== sp2.termsClause)
        //     return false;
        // if (sp1.termsMode !== sp2.termsMode)
        //     return false;
        // if (sp1.filterValuesClause !== sp2.filterValuesClause)
        //     return false;
        // if (sp1.filterGroupsClause !== sp2.filterGroupsClause)
        //     return false;

        // termsSearchedFields
        // const termsSearchedFields1 = sp1.termsSearchedFields || [] as string[];
        // const termsSearchedFields2 = sp2.termsSearchedFields || [] as string[];
        // if (termsSearchedFields1.length !== termsSearchedFields2.length)
        //     return false;
        // for (let i = 0; i < termsSearchedFields1.length; i++) {
        //     const x1 = termsSearchedFields1[i];
        //     var exists = false;
        //     for (let j = 0; j < termsSearchedFields2.length; j++) {
        //         const x2 = termsSearchedFields2[j];
        //         if (x1 === x2) {
        //             exists = true;
        //             break;
        //         }
        //     }
        //     if (!exists)
        //         return false;
        // }

        // terms
        if (sp1.originalTerms !== sp2.originalTerms)
            return false;
        const terms1 = sp1.terms || [] as string[];
        const terms2 = sp2.terms || [] as string[];
        if (terms1.length !== terms2.length)
            return false;
        for (let i = 0; i < terms1.length; i++) {
            const x1 = terms1[i];
            var exists = false;
            for (let j = 0; j < terms2.length; j++) {
                const x2 = terms2[j];
                if (x1 === x2) {
                    exists = true;
                    break;
                }
            }
            if (!exists)
                return false;
        }

        // filters
        const filters1 = sp1.filters || [] as common.ISearchFilter[];
        const filters2 = sp2.filters || [] as common.ISearchFilter[];
        if (filters1.length !== filters2.length)
            return false;
        for (let i = 0; i < filters1.length; i++) {
            const x1 = filters1[i];
            const v1 = x1.values || [] as string[];
            var exists = false;
            for (let j = 0; j < filters2.length; j++) {
                const x2 = filters2[j];
                if (x1.fieldName === x2.fieldName) {
                    const v2 = x2.values || [] as string[];
                    if (v1.length != v2.length)
                        return false;
                    for (let ii = 0; ii < v1.length; ii++) {
                        var exists2 = false;
                        for (let jj = 0; jj < v2.length; jj++)
                            if (v1[ii] === v2[jj]) {
                                exists2 = true;
                                break;
                            }
                        if (!exists2)
                            return false;
                    }
                    exists = true;
                    break;
                }
            }
            if (!exists)
                return false;
        }

        // sorters
        const sorters1 = sp1.sorters || [] as common.ISearchSorter[];
        const sorters2 = sp2.sorters || [] as common.ISearchSorter[];
        if (sorters1.length !== sorters2.length)
            return false;
        for (let i = 0; i < sorters1.length; i++) {
            const x1 = sorters1[i];
            const o1 = x1.order || '';
            var exists = false;
            for (let j = 0; j < sorters2.length; j++) {
                const x2 = sorters2[j];
                const o2 = x2.order || '';
                if (o1 === o2) {
                    exists = true;
                    break;
                }
            }
            if (!exists)
                return false;
        }

        return true;
    }

    /** Permet de mettre a jour la 'destination' a partir de la 'source' */
    updateSearchParameters(destination: common.ISearchParameters, source: common.ISearchParameters) {
        destination = destination || {} as common.ISearchParameters;
        source = source || {} as common.ISearchParameters;

        this.updateSearchParametersPaging(destination, source);
        this.updateSearchParametersTerms(destination, source);
        this.updateSearchParametersFilters(destination, source);
        this.updateSearchParametersSorters(destination, source);

        return destination;
    }

    /** Permet de mettre a jour la 'destination' a partir de la 'source' */
    updateSearchParametersPaging(destination: common.ISearchParameters, source: common.ISearchParameters) {
        destination = destination || {} as common.ISearchParameters;
        source = source || {} as common.ISearchParameters;

        destination.pageSize = source.pageSize;
        destination.pageNumber = source.pageNumber;
    }

    /** Permet de mettre a jour la 'destination' a partir de la 'source' */
    updateSearchParametersTerms(destination: common.ISearchParameters, source: common.ISearchParameters) {
        destination = destination || {} as common.ISearchParameters;
        source = source || {} as common.ISearchParameters;

        destination.termsClause = source.termsClause;
        destination.termsMode = source.termsMode;
        destination.originalTerms = source.originalTerms;

        // termsSearchedFields ==========================
        if (source.termsSearchedFields) {
            destination.termsSearchedFields = [];
            for (let i = 0; i < source.termsSearchedFields.length; i++)
                destination.termsSearchedFields[i] = source.termsSearchedFields[i];
        }
        else {
            destination.termsSearchedFields = null;
        }

        // terms =========================================
        if (source.terms) {
            destination.terms = [];
            for (let i = 0; i < source.terms.length; i++)
                destination.terms[i] = source.terms[i];
        }
        else {
            destination.terms = null;
        }

        return destination;
    }

    /** Permet de mettre a jour la 'destination' a partir de la 'source' */
    updateSearchParametersFilters(destination: common.ISearchParameters, source: common.ISearchParameters,) {
        destination = destination || {} as common.ISearchParameters;
        source = source || {} as common.ISearchParameters;

        destination.filterGroupsClause = source.filterGroupsClause;
        destination.filterValuesClause = source.filterValuesClause;

        // filters ======================================
        if (source.filters) {
            destination.filters = [];
            for (let i = 0; i < source.filters.length; i++) {
                let f = source.filters[i];
                destination.filters[i] = {
                    fieldName: f.fieldName
                } as common.ISearchFilter;
                if (f.values) {
                    destination.filters[i].values = [];
                    for (let j = 0; j < f.values.length; j++)
                        destination.filters[i].values[j] = f.values[j];
                } else {
                    destination.filters[i].values = null;
                }
            }
        }
        else {
            destination.filters = null;
        }

        return destination;
    }

    /** Permet de mettre a jour la 'destination' a partir de la 'source' */
    updateSearchParametersSorters(destination: common.ISearchParameters, source: common.ISearchParameters) {
        destination = destination || {} as common.ISearchParameters;
        source = source || {} as common.ISearchParameters;

        // sorters =======================================
        if (source.sorters) {
            destination.sorters = [];
            for (let i = 0; i < source.sorters.length; i++) {
                let s = source.sorters[i];
                destination.sorters[i] = {
                    fieldName: s.fieldName,
                    order: s.order,
                    sorterType: s.sorterType
                } as common.ISearchSorter;
            }
        }
        else {
            destination.sorters = null;
        }

        return destination;
    }
    /** Permet d'ajouter des filtres a des search parameters */
    appendSearchParametersFilters(sp: common.ISearchParameters, filters: common.ISearchFilter[]) {
        sp = sp || {} as common.ISearchParameters;
        sp.filters = sp.filters ?? [] as common.ISearchFilter[];
        filters = filters || [] as common.ISearchFilter[];

        var getFilterByName = (name: string) => {
            for (let i = 0; i < sp.filters.length; i++) {
                const f = sp.filters[i];
                if (f.fieldName === name)
                    return f;
            }
            return null;
        };

        for (let i = 0; i < filters.length; i++) {
            const f = filters[i];
            var existing = getFilterByName(f.fieldName);
            if (!existing) {
                existing = {
                    fieldName: f.fieldName,
                    values: []
                } as common.ISearchFilter;
                sp.filters.push(existing);
            }
            for (let j = 0; j < (f.values || []).length; j++)
                existing.values.push(f.values[j]);//copy
        }
        return sp;
    }

    buildUrlFromFormat(urlFormat?: string, placeholderValuePairsArray?: any[]) {
        if (!placeholderValuePairsArray) placeholderValuePairsArray = [];

        var url = urlFormat || '';

        for (let i = 0; i < placeholderValuePairsArray.length; i++) {
            const pair = placeholderValuePairsArray[i];
            url = (url as any).replace(pair.key, pair.value);
        }

        return url;
    }

    contains(value: string, searchedValue: string) {
        return value.indexOf(searchedValue) > -1;
    }

    // preventEnter() {
    //     return !(window.event && (window.event as KeyboardEvent).keyCode === Utilities.keyCodes.enter);
    // }

    removeAllQuerStringDelimiter(string: string, replaceWithSpace: boolean) {
        return string.replace(/[\?\&]/g, replaceWithSpace ? ' ' : '');
    }

    initializeClickButtonOnEnter(settings: any) {
        if (!settings) throw "[UPA] settings cannot be null";
        if (!settings.textFieldTarget) return;
        if (!settings.buttonTarget) return;

        const textFields = $(settings.textFieldTarget);

        if (!textFields) return;

        const buttons = $(settings.buttonTarget);

        if (!buttons) return;

        this.clickButtonOnEnter(textFields.first(), buttons.first());
    }

    clickButtonOnEnterFromTargets(fieldsTarget: string, buttonTarget: string) {
        if (!fieldsTarget || !buttonTarget) return;
        const $f = $(fieldsTarget);
        const $b = $(buttonTarget);
        this.clickButtonOnEnter($f, $b);
    }

    clickButtonOnEnter($fields: JQuery, $button: JQuery) {
        if (!$fields || !$fields.length || !$button || !$button.length) return;
        $fields.on('keydown', (e: any) => {
            if (e.keyCode !== Utilities.keyCodes.enter) return;

            e.preventDefault();

            if (!$button) return;
            $button.trigger('click');
        });
    }

    initializeClickButtonOnChange(settings: any) {
        if (!settings) throw "[UPA] settings cannot be null";
        if (!settings.selectsTarget) return;
        if (!settings.buttonTarget) return;

        const selects = $(settings.selectsTarget);

        if (!selects) return;

        const buttons = $(settings.buttonTarget);

        if (!buttons) return;

        this.clickButtonOnChange(selects, buttons.first());
    }

    clickButtonOnChange($selectElements: JQuery, $buttonElement: JQuery) {
        //ready for Select2.
        $selectElements.on('change',
            e => {
                if (!$buttonElement) return;

                $buttonElement.trigger('click');

                e.preventDefault();
            });
    }


    isNullOrUndefined(obj: Object) {
        return (typeof obj === 'undefined' || obj === null);
    }

    getElements(target: String) {
        const $elements = $(target as any);
        return $elements && $elements.length ? $elements : null;
    }

    getFirstElement(target: String) {
        const $elements = this.getElements(target);
        if (!$elements || !$elements.length) return null;
        return $elements.first() || null;
    }

    getData($element: JQuery, key: string) {
        if (!$element || !key) return null;
        return $element.data(key);
    }

    setData($element: JQuery, key: string, value: any) {
        if (!$element || !key) return null;
        return $element.data(key, value);
    }

    isEmptyObject(obj: Object) {
        return (Object.keys(obj || {}).length > 0);
    }

    getBodyElement() {
        if (this._body !== null) return this._body;

        const element = document.getElementById(Utilities.ids.mainBody);

        if (!element) throw ('[UPA] The body must have an id with a value "' + Utilities.ids.mainBody + '".');

        this._body = $(element);

        return this._body;
    }

    addDisabledAttribute($element: JQuery) {
        $element.attr(Utilities.attributes.disabled, Utilities.attributes.disabled);
    }

    removeDisabledAttribute($element: JQuery) {
        $element.removeAttr(Utilities.attributes.disabled);
    }


    getFilesFromInput(element: HTMLInputElement, maxFiles?: number, maxSizeMb?: number) {
        if (!element)
            throw "L'argument 'element:HTMLInputElement' est NULL.";
        maxFiles = maxFiles || context.upload.defaultMaxFiles;
        const maxSize = (maxSizeMb || context.upload.defaultMaxFileSizeMb) * 1024 * 1024;
        const results = {
            files: [],
            hasMaxFilesError: false,
            hasMaxFileSizeMbErrors: false,
            maxFilesErrorMessage: null,
            maxFileSizeMbErrorMessages: []
        } as common.IValidatedFiles;
        if (element.files.length > maxFiles) {
            results.hasMaxFilesError = true;
            results.maxFilesErrorMessage = "Le nombre maximum de fichiers est " + maxFiles + ".";
            return results;
        }
        for (let i = 0; i < element.files.length; i++) {
            const file = element.files[i];
            if (!file || !file.size) {
                results.hasMaxFileSizeMbErrors = true;
                results.maxFileSizeMbErrorMessages.push("Le fichier '" + file.name + "' est vide.");
                continue;
            };
            if (maxSize && file.size > maxSize) {
                results.hasMaxFileSizeMbErrors = true;
                results.maxFileSizeMbErrorMessages.push("Le fichier '" + file.name + "' est trop volumineux. La taille maximale est de " + maxSizeMb + "Mb.");
                continue;
            }
            results.files.push(file);
        }
        return results;
    }
    /** OBSOLETE: Methode conservee pour la retrocompatibilite. Utiliser 'utilities.getFilesFromInput(...)' lorsque possible.
     //NOTE: Le champ cible par le 'fieldId' doit etre un input[type=file] */
    getFiles(fieldId: string, errorMessagesAggregator: string[], maxFiles?: number, maxSizeMb?: number) {
        const element = window.document.getElementById(fieldId) as HTMLInputElement;
        const r = this.getFilesFromInput(element, maxFiles, maxSizeMb);
        if (r.hasMaxFilesError)
            errorMessagesAggregator.push(r.maxFilesErrorMessage);
        if (r.hasMaxFileSizeMbErrors)
            for (let i = 0; i < (r.maxFileSizeMbErrorMessages || []).length; i++)
                errorMessagesAggregator.push(r.maxFileSizeMbErrorMessages[i]);
        return r.files;
    }

    screenIsPhone() {
        const w = this.getScreenWidth();
        return w <= this.config.screenBreakPoints.phone;
    }

    getScreenWidth() {
        return this.getBodyElement().width();
    }

    screenIsTablet() {
        const w = this.getScreenWidth();
        return w > this.config.screenBreakPoints.phone && w <= this.config.screenBreakPoints.tablet;
    }

    screenIsDesktop() {
        const w = this.getScreenWidth();
        return w > this.config.screenBreakPoints.tablet;
    }

    isIe() {
        return this.isIe10OrLess() || this.isIe11();
    }

    isIe10OrLess() {
        return this.testUserAgent("MSIE");
    }

    isIe11() {
        return this.testUserAgent("Trident");
    }

    isEdge() {
        return this.testUserAgent("Edge");
    }

    isCrappyBrowser() {
        return this.isIe() || this.isIe10OrLess() || this.isEdge() || this.isSafari();
    }

    isFireFox() {
        return this.testUserAgent("Firefox");
    }

    isSafari() {
        const result = /Safari/.test(this.getUserAgent()) && /Apple Computer/.test(this.getVendor());
        return result;
    }

    isMobileDevice() {
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(this.getUserAgent(true));
    }

    testUserAgent(text: string) {
        if (!text) return false;
        const ua = this.getUserAgent(true);
        const result = ua.indexOf(text.toLowerCase());
        return result >= 0;
    }

    getUserAgent(lowerCase?: boolean) {
        lowerCase = lowerCase === true;
        const value = window.navigator.userAgent;
        return lowerCase ? value.toLowerCase() : value;
    }

    getVendor(lowerCase?: boolean) {
        lowerCase = lowerCase === true;
        const value = window.navigator.vendor;
        return lowerCase ? value.toLowerCase() : value;
    }

    resetInputFile = ($inputFile: JQuery, preserveEvent?: boolean) => {
        const $clone = $inputFile.val('').clone(preserveEvent === true);
        $inputFile.replaceWith($clone);
        return $clone;
    };

    encode(value: string) {
        const encoded = encodeURIComponent(value || '')
            .replace(/\+/g, '%2B')
            .replace(/\*/g, '%2A')
            .replace(/\@/g, '%21')
            .replace(/\'/g, '%27')
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29')
            .replace(/\~/g, '%7E');

        return encoded;
    }

    topOffset() {
        return $(window.document).scrollTop();
    }

    scrollToTop(animationDuration?: number, target?: string, easing?: string, callback?: () => void) {
        this.goTo(0, animationDuration, target, easing, callback);
    }

    scrollTo($element: JQuery, animationDuration?: number, target?: string, offset?: number, easing?: string, callback?: () => void) {
        var y = $element.first().offset().top;
        y += offset || 0;
        this.goTo(y, animationDuration, target, easing, callback);
    }

    goTo(y: number, animationDuration?: number, target?: string, easing?: string, callback?: () => void) {
        target = target || 'html, body';
        const min = 1;
        const d = Math.max(animationDuration || min, min);
        $(target).animate({
            scrollTop: y,
            duration: d,
            easing: easing || 'easeOutCubic',
            complete: callback
        } as any);
    }

    focus($element: JQuery, delay?: number) {
        const f = () => {
            $element.trigger('focus');
        };

        if (!delay || delay < 0)
            f();
        else
            setTimeout(f, delay);
    }

    asChecked($checkbox: JQuery, isChecked?: boolean) {
        const checked = 'checked';
        if (isChecked === false)
            $checkbox.removeAttr(checked);
        else
            $checkbox.attr(checked, checked);
        $checkbox.trigger('change');
        return this;
    }

    copyProperties(a: {}, b: {}) {
        a = a || {};
        b = b || {};
        for (let k in a) {
            if (a.hasOwnProperty(k))
                b[k] = a[k]
        }
        return this;
    }

    aggregate(a: any[], b: any[]) {
        if (!a) a = [];
        if (!b) b = [];
        for (let i = 0; i < b.length; i++)
            a.push(b[i]);
        return a;
    }

    messagesToErrors(messages: string[]) {
        const errors = [] as common.IError[];
        if (!messages) return errors;
        for (let i = 0; i < messages.length; i++) {
            const error = new core.Error(messages[i], null);
            errors.push(error);
        }
        return errors;
    }

    messagesToErrorObjects(messages: string[]) {
        const errors = this.messagesToErrors(messages);
        const objects = [] as {}[];
        for (let i = 0; i < errors.length; i++) {
            const e = errors[i] as common.IError;
            objects.push(e.toObject())
        }
        return objects;
    }

    updateBrowserUrl(url: string, updateAlsoHistory?: boolean) {
        const w = (window as any);
        const t = w.document.title;
        if (updateAlsoHistory === true)
            w.history.pushState({}, t, url);
        else
            w.history.replaceState({}, t, url);
        return this;
    }

    extractQueryString(url: string) {
        if (!url)
            return {};
        const parts = url.split('?');
        if (!parts.length)
            return {};
        const qs = parts[parts.length === 1 ? 0 : 1];
        const data = querystringify.parse(qs);
        return data || {};
    }
    /** Lancera une exception si le navigationContext y est absent ET que l'environnement est LOCAL | DEV. */
    navigationContextExistsInUrl(url: string) {
        const qs = this.extractQueryString(url);
        return qs && qs[context.url.parameters.navigationContext];
    }
    removeEntry(collection: Array<any>, index: number) {
        if (!collection)
            return [];

        delete collection[index];

        if (index === 0)
            return collection.splice(1); //delete first item

        const firstPart = collection.splice(0, index);

        if (collection.length < 2)
            return firstPart;

        const secondPart = collection.splice(1, collection.length - 1);

        return firstPart.concat(secondPart);
    }

    initializeAllCheckboxes(config?: common.IInitializeAllCheckboxesConfig) {
        const _initializedInstances = [];
        const _config = config ||
            {
                rootTarget: null,
                modTarget: null,
                forceReinitAll: false,
                forceReinit: null,
                onChangeAction: null,
                onCheckAction: null,
                onPreInit: null,
                onInitCompleted: null
            } as common.IInitializeAllCheckboxesConfig;
        const _$root = _config.rootTarget ? $(_config.rootTarget) : $('body');
        const _$all = _$root.find(_config.modTarget || '.mod-checkbox');
        if (_config.forceReinitAll === true) {
            const hasRootTarget = _config.rootTarget && _config.rootTarget.length > 0;
            for (let i = 0; i < jsClasses.instances.checkboxes.length; i++) {
                const checkbox = jsClasses.instances.checkboxes[i];
                if (!hasRootTarget || isTargeted(checkbox)) {
                    checkbox.dispose();
                    jsClasses.instances.checkboxes = this.removeEntry(jsClasses.instances.checkboxes, i);
                    i--;
                }
            }
        }
        for (let i = 0; i < _$all.length; i++) {
            const $e = $(_$all[i]).first();
            var alreadyInstanciated = false;
            var instance: any;
            for (let j = 0; j < jsClasses.instances.checkboxes.length; j++) {
                instance = jsClasses.instances.checkboxes[j];
                if (instance.$mod().first().is($e)) {
                    alreadyInstanciated = true;
                    if (_config.forceReinit) {
                        if (_config.forceReinit(instance)) {
                            instance.dispose();
                            instance = null;
                            jsClasses.instances.checkboxes.splice(j, 1);
                            alreadyInstanciated = false;
                        }
                    }
                    break;
                }
            }
            if (alreadyInstanciated)
                continue;
            instance = new jsClasses.Checkbox($e[0]);
            if (_config.onPreInit) _config.onPreInit(instance);
            instance.init(_config.onChangeAction || null, _config.onCheckAction || null);
            if (_config.onInitCompleted) _config.onInitCompleted(instance);
            _initializedInstances.push(instance);
        }
        return _initializedInstances;

        function isTargeted(chx: any) {
            for (let i = 0; i < _$all.length; i++) {
                if ((_$all[i] as Element) === (chx.$mod()[0] as Element))
                    return true;
            }
            return false;
        }
    }
    updateUrlParameter(url: string, parameterName: string, parameterValue: string) {
        if (!parameterName)
            return url || '';
        const params = {};
        params[parameterName] = parameterValue || '';
        return this.updateUrlParameters(url, params);
    }
    /** Parameters doit etre un object dont la cle est le ParameterName (string) et la valeur est le ParameterValue (string) */
    updateUrlParameters(url: string, parameters: {}) {
        url = url || '';
        if (!parameters)
            return url;
        const getParamValue = (name: string) => parameters[name] || parameters[name] === '' ? parameters[name] : null;
        var baseUrl: string;
        var query: string;
        if (url.indexOf('?') >= 0) {
            const urlParts = url.split('?');
            baseUrl = urlParts[0];
            query = urlParts[1] || '';
        }
        else {
            baseUrl = url;
            query = '';
        }
        const queryParts = query.split('&');
        const newParams = {};
        for (let i = 0; i < queryParts.length; i++) {
            const param = queryParts[i];
            var k: string;
            var v: string;
            if (param.indexOf('=') >= 0) {
                const paramParts = param.split('=');
                k = paramParts[0];
                v = paramParts[1] || '';
            }
            else {
                k = param;
                v = '';
            }
            const paramValueToUpdate = getParamValue(k);
            if (paramValueToUpdate !== null)
                v = paramValueToUpdate;
            newParams[k] = v;
        }
        for (let k in parameters)
            if (parameters.hasOwnProperty(k))
                if (!newParams[k] && newParams[k] !== '')
                    newParams[k] = parameters[k];
        var newQuery = '';
        for (let k in newParams)
            if (newParams.hasOwnProperty(k)) {
                if (newQuery.length)
                    newQuery += '&';
                newQuery += k + '=' + newParams[k];
            }

        const newUrl = newQuery ? baseUrl + '?' + newQuery : baseUrl;
        return newUrl;
    }

    //initializeAllRadiobuttons(config?: common.IInitializeAllRadiobuttonsConfig) {
    //    var i;
    //    var initializedInstances = [];
    //    var _config = config ||
    //        {
    //            modTarget: null,
    //            forceReinitAll: false,
    //            forceReinit: null,
    //            onChangeAction: null,
    //            onPreInit: null,
    //            onInitCompleted: null
    //        } as common.IInitializeAllRadiobuttonsConfig;
    //    if (_config.forceReinitAll === true) {
    //        for (i = 0; i < jsClasses.instances.radiobuttons.length; i++)
    //            jsClasses.instances.radiobuttons[i].dispose();
    //        jsClasses.instances.radiobuttons[i] = null;
    //        jsClasses.instances.radiobuttons = [];
    //    }
    //    var $all = $(_config.modTarget || '.mod-radiobutton');
    //    for (i = 0; i < $all.length; i++) {
    //        var $e = $($all[i]);
    //        var instance: any;
    //        var alreadyInstanciated = false;
    //        for (var j = 0; j < jsClasses.instances.radiobuttons.length; j++) {
    //            instance = jsClasses.instances.radiobuttons[j];
    //            if (instance.$mod().is($e)) {
    //                alreadyInstanciated = true;
    //                if (_config.forceReinit)
    //                    if (_config.forceReinit(instance)) {
    //                        instance.dispose();
    //                        instance = null;
    //                        jsClasses.instances.radiobuttons.splice(j, 1);
    //                        alreadyInstanciated = false;
    //                    }
    //                break;
    //            }
    //        }
    //        if (alreadyInstanciated)
    //            continue;
    //        instance = new jsClasses.Radiobutton($e[0]);
    //        if (_config.onPreInit) _config.onPreInit(instance);
    //        instance.init(_config.onChangeAction || null);
    //        if (_config.onInitCompleted) _config.onInitCompleted(instance);
    //        initializedInstances.push(instance);
    //    }

    //    //$(_config.modTarget || '.mod-radiobutton')
    //    //    .each(function () {
    //    //        var $this = $(this);
    //    //        var instance;
    //    //        var alreadyInstanciated = false;
    //    //        for (i = 0; i < jsClasses.instances.radiobuttons.length; i++) {
    //    //            instance = jsClasses.instances.radiobuttons[i];
    //    //            if (instance.$mod().is($this)) {
    //    //                alreadyInstanciated = true;
    //    //                if (_config.forceReinit) {
    //    //                    if (_config.forceReinit(instance)) {
    //    //                        instance.dispose();
    //    //                        instance = null;
    //    //                        jsClasses.instances.radiobuttons.splice(i, 1);
    //    //                        alreadyInstanciated = false;
    //    //                    }
    //    //                }
    //    //                break;
    //    //            }
    //    //        }
    //    //        if (alreadyInstanciated) return;
    //    //        instance = new jsClasses.Radiobutton(this);
    //    //        if (_config.onPreInit) _config.onPreInit(instance);
    //    //        instance.init(_config.onChangeAction || null);
    //    //        if (_config.onInitCompleted) _config.onInitCompleted(instance);
    //    //        initializedInstances.push(instance);
    //    //    });
    //    return initializedInstances;
    //}

    // initializeBoxCollapsor($root?: JQuery, configuration?: common.IInitializeBoxCollapsorConfig) {
    //     configuration = configuration ||
    //         {
    //             modTarget: null,
    //             buttonTarget: null,
    //             boxTarget: null,
    //             buttonAltTarget: null,
    //             buttonIsOutside: null,
    //             buttonAltIsOutside: null,
    //             onChangeState: null
    //         } as common.IInitializeBoxCollapsorConfig;

    //     const modTarget = configuration.modTarget || '.mod-box-collapsor';
    //     const boxTarget = configuration.boxTarget || '.mbcol-content';
    //     const buttonTarget = configuration.buttonTarget || '.mbcol-button';
    //     const buttonAltTarget = configuration.buttonAltTarget || null;
    //     //ATTENTION : Si config.buttonIsOutside / config.buttonAltIsOutside est TRUE, le config.modTarget doit être spécific (utiliser un ID).
    //     const buttonIsOutside = configuration.buttonIsOutside === true;
    //     const buttonAltIsOutside = configuration.buttonAltIsOutside === true;
    //     const stateAttrName = 'collapsor-state';
    //     const bypassAttrName = 'collapsor-bypass';
    //     const states = {
    //         opened: 'opened',
    //         closed: 'closed'
    //     };

    //     const $all = getMod();
    //     for (let i = 0; i < $all.length; i++) {
    //         const $m = $($all[i] as any);
    //         if (isBypassed($m))
    //             continue;
    //         const $b = retrieveButton($m);
    //         const $ba = retrieveButtonAlt($m);
    //         const existingState = $b.attr(stateAttrName) || null;
    //         setState($b, $m, existingState === states.opened ? states.closed : states.opened);
    //         toggle($m, $b);
    //         setupButton($b,
    //             $this => {
    //                 var $thisMod = retrieveMod($this, buttonIsOutside);
    //                 toggle($thisMod, $this);
    //             });
    //         if ($ba)
    //             setupButton($ba,
    //                 $this => {
    //                     const $thisMod = retrieveMod($this, buttonAltIsOutside);
    //                     const $thisButton = retrieveButton($thisMod);
    //                     toggle($thisMod, $thisButton);
    //                 });
    //     }

    //     return $all;

    //     function setupButton($button: JQuery, onClick: ($thisButton: JQuery) => void) {
    //         return $button
    //             .css('cursor', 'pointer')
    //             .unbind('click')
    //             .bind('click',
    //                 e => {
    //                     const $this = $(e.currentTarget);
    //                     onClick($this);
    //                 });
    //     }

    //     function isBypassed($mod: JQuery) {
    //         return $mod.attr(bypassAttrName) === 'true';
    //     }

    //     function getMod() {
    //         return $root ? $root.find(modTarget) : $(modTarget);
    //     }

    //     function getState($button: JQuery) {
    //         return $button.attr(stateAttrName) === states.opened
    //             ? states.opened
    //             : states.closed;
    //     }

    //     function setState($button: JQuery, $mod: JQuery, state: string) {
    //         $mod.attr(stateAttrName, state);
    //         $button
    //             .attr(stateAttrName, state)
    //             .removeClass(states.opened)
    //             .removeClass(states.closed)
    //             .addClass(state);
    //     }

    //     function toggle($mod: JQuery, $button: JQuery) {
    //         const currentState = getState($button);
    //         const newState = currentState === states.closed ? states.opened : states.closed;
    //         const $box = $mod.find(boxTarget);
    //         if (newState === states.opened)
    //             $box.show();
    //         else
    //             $box.hide();
    //         setState($button, $mod, newState);
    //         if (configuration.onChangeState)
    //             configuration.onChangeState(newState, $mod, $box, $button);
    //     }

    //     function retrieveMod($this: JQuery, isOutside: boolean) {
    //         return isOutside
    //             ? getMod()
    //             : $this.closest(modTarget);
    //     }

    //     function retrieveButton($mod: JQuery) {
    //         if (!buttonTarget)
    //             return null;
    //         if (buttonIsOutside)
    //             return $root ? $root.find(buttonTarget) : $(buttonTarget);
    //         return $mod.find(buttonTarget);
    //     }

    //     function retrieveButtonAlt($mod: JQuery) {
    //         if (!buttonAltTarget)
    //             return null;
    //         if (buttonAltIsOutside)
    //             return $root ? $root.find(buttonAltTarget) : $(buttonAltTarget);
    //         return $mod.find(buttonAltTarget);
    //     }
    // }

    // initializeItemsCollapsor($root?: JQuery,
    //     forceReinit?: boolean,
    //     onPreInit?: ($module: JQuery) => void,
    //     onChange?: ($module: JQuery, isExpanded: boolean) => void) {
    //     const defaultThreshold = 5;
    //     const rootTarget = '[collapsor]';
    //     const modCssClass = 'mod-items-collapsor';
    //     const isExpandedCssClass = 'expanded';
    //     const isHiddenCssClass = 'hidden';
    //     const linkHtml =
    //         '<span class="micol-link" collapsor-link title=""><span class="text"></span><span class="icon"></span></span>';
    //     const linkCssClassVariants = { more: 'more', less: 'less' };

    //     forceReinit = forceReinit !== false;

    //     const $all = $root ? $root.find(rootTarget) : $(rootTarget);

    //     const isExpanded = ($r: JQuery): boolean => {
    //         return $r.hasClass(isExpandedCssClass);
    //     };
    //     const getItems = ($r: JQuery): JQuery => {
    //         return $r.find('[collapsor-item]');
    //     };
    //     const getLink = ($r: JQuery): JQuery => {
    //         return $r.find('[collapsor-link]');
    //     };
    //     const getThresh = ($r: JQuery): number => {
    //         return parseInt($r.attr('collapsor-threshold') || defaultThreshold.toString());
    //     };
    //     const collapse = ($r: JQuery): JQuery => {
    //         const text = $r.attr('collapsor-more') || 'Plus';
    //         const threshold = getThresh($r);
    //         const $link = getLink($r);
    //         const $items = getItems($r);
    //         for (let n = 0; n < $items.length; n++) {
    //             const $i = $($items[n] as any);
    //             if (n < threshold)
    //                 $i.show();
    //             else
    //                 $i.hide();
    //         }
    //         $r.removeClass(isExpandedCssClass);
    //         $link
    //             .removeClass(linkCssClassVariants.less)
    //             .addClass(linkCssClassVariants.more)
    //             .attr('title', text)
    //             .find('.text')
    //             .html(text);
    //         return $items;
    //     };
    //     var expand = ($r: JQuery): JQuery => {
    //         const text = $r.attr('collapsor-less') || 'Moins';
    //         const $link = getLink($r);
    //         const $items = getItems($r);
    //         for (let n = 0; n < $items.length; n++) {
    //             const $i = $($items[n] as any);
    //             $i.show();
    //         }
    //         $r.addClass(isExpandedCssClass);
    //         $link
    //             .removeClass(linkCssClassVariants.more)
    //             .addClass(linkCssClassVariants.less)
    //             .attr('title', text)
    //             .find('.text')
    //             .html(text);
    //         return $items;
    //     };
    //     for (let i = 0; i < $all.length; i++) {
    //         const $m = $($all[i] as any);

    //         if (onPreInit) onPreInit($m);

    //         const isAlreadyInit = $m.hasClass(modCssClass);

    //         if (isAlreadyInit) {
    //             if (!forceReinit)
    //                 continue;

    //             //reinitialization
    //             $m.removeClass(modCssClass)
    //                 .removeClass(isExpandedCssClass)
    //                 .find('[collapsor-link]')
    //                 .remove();
    //         }

    //         const count = getItems($m).length;
    //         const limit = getThresh($m) + 1;

    //         if (count < limit)
    //             continue;

    //         $m.addClass(isHiddenCssClass).append($(linkHtml).on('click', e => {
    //             e.preventDefault();
    //             const $this = $(e.currentTarget as any);
    //             const $r = $this.closest('[collapsor]');
    //             const mustCollapse = isExpanded($r);
    //             if (mustCollapse)
    //                 collapse($r);
    //             else
    //                 expand($r);

    //             if (onChange) onChange($r, !mustCollapse);
    //         }));

    //         //initialization
    //         (($r: JQuery, isExpandedOnInit: boolean) => {
    //             const $items = isExpandedOnInit ? expand($r) : collapse($r);
    //             $r.addClass(modCssClass);
    //             $items.parent().addClass('micol-items');
    //             for (let j = 0; j < $items.length; j++) {
    //                 const $i = $($items[j] as any);
    //                 $i.addClass('micol-item');
    //             }
    //             if (onChange) onChange($r, isExpandedOnInit);
    //         })($m, isExpanded($m));

    //         $m.removeClass(isHiddenCssClass);
    //     }
    //     return $all;
    // }

    asString(obj: any) {
        var value: string;
        try {
            value = JSON.stringify(obj);
        } catch (e) {
            return null;
        }
        return value;
    }

    asObject(value: string) {
        var obj: any;
        try {
            obj = JSON.parse(value);
        } catch (e) {
            return null;
        }
        return obj;
    }

    formatDateFromString(stringDate: string, inputMomentFormat?: string, outputMomentFormat?: string, lang?: string) {
        const date = (inputMomentFormat ? moment(stringDate, inputMomentFormat) : moment(stringDate))._d;
        return this.formatDate(date, outputMomentFormat, lang);
    }

    formatNow(outputMomentFormat?: string, lang?: string) {
        const now = new Date();
        return this.formatDate(now, outputMomentFormat, lang);
    }

    formatDate(date: Date, outputMomentFormat?: string, lang?: string) {
        outputMomentFormat = outputMomentFormat || 'LLLL'; //default
        lang = lang || 'fr-ca';
        const formated = moment(date).locale(lang).format(outputMomentFormat);
        return formated;
    }

    showElementOnDropdownValueChange(dropdownTarget: string, value: string, elementTarget) {
        const $element = $(dropdownTarget).on('change', () => {
            udpate($element);
        });
        udpate($element);

        function udpate($e: JQuery) {
            const $o = $e.find('option:selected');
            const v = $o.val();
            const $p = $(elementTarget);
            if (v === value)
                $p.show();
            else
                $p.hide();
        }
    }

    showElementOnDropdownTitleChange(dropdownTarget: string, title: string, elementTarget) {
        const $element = $(dropdownTarget).on('change', () => {
            udpate($element);
        });
        udpate($element);

        function udpate($e: JQuery) {
            const $o = $e.find('option:selected');
            const t = $o.html().toLowerCase().trim();
            const $p = $(elementTarget);
            if (t === title.toLowerCase().trim())
                $p.show();
            else
                $p.hide();
        }
    }

    formatZipCode(zipCode: string) {
        if (!zipCode) return '';
        zipCode = zipCode.toUpperCase();
        if (zipCode.length !== 6) return zipCode;
        const formatedZipCode = zipCode.slice(0, 3) + ' ' + zipCode.slice(3, 6);
        return formatedZipCode;
    };

    onClick = {
        stopPropagation: (event: Event) => {
            event.stopPropagation();
        },
        preventDefault: (event: Event) => {
            event.preventDefault();
        },
        preventDefaultAndStopPropagation: (event: Event) => {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    initializeDropdownControls(settings: any) {
        settings = settings ||
        {
            configurations: [
                {
                    collapsedPageContentTarget: '.mp-main',
                    collapsedPageContentCssClass: 'collapsed',
                    selectId: null,
                    labelId: null,
                    rootTarget: null,
                    skinOptions: null,
                    //animationOption: null,
                    initializeOnCreation: true
                }
            ]
        };
        const configurations = settings.configurations || [];
        const instances = [];
        for (let i = 0; i < configurations.length; i++) {
            const d = new core.DropdownControl(configurations[i]);
            instances.push(d);
        }
        return instances;
    }

    initializeDynamicElements($root?: JQuery, inputEventName?: string) {
        /*	Dynamic element
 
            Noeuds HTML dynamiques dont la visibilité est tributaire de la valeur d'un champs de formulaire.
 
            Attributs :
            - dynamic-element (required) : identifie un element dynamique
            - dynamic-element--field-target (required) : identifie le selecteur du champ de formulaire dont la visibilité est tributaire
            - dynamic-element--field-value (required) : identifie la valeur que le champ de formulaire doit avoir afin de rendre visible l'element dynamique. Séparer les valeurs par l'opérateur '||' (ou), voir l'exemple ci-dessous.
 
            Paramêtres d'inititialization :
            - $root (optionel) : Element jquery qui scope l'initialisation (par défaut, sera le 'body')
            - inputEventName (optionel) : nom de l'événement écouté pour mettre à jour l'élément dynamique (par défaut, sera 'change').
 
            Utilisation :
 
            <select name="MonChamps">
                <option value="a" selected="selected">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
            </select>
            <p dynamic-element dynamic-element--field-target="[name='MonChamps']" dynamic-element--field-value="b || c">Visible seulement lorsque MonChamps vaut 'b' ou 'c'.</p>
 
            JS> utilities.initializeDynamicElements();
        */
        const dynamicElementAttribute = "dynamic-element";
        const dynamicElementFieldTargetAttribute = "dynamic-element--field-target";
        const dynamicElementFieldValueAttribute = "dynamic-element--field-value";
        const dynamicElementIdAttribute = "dynamic-element--id";
        const dynamicElementRefAttribute = "dynamic-element--ref";
        $root = $root || $('body') || [] as any;
        inputEventName = inputEventName || 'change';
        const $dynamicFields = $root.find('[' + dynamicElementAttribute + ']');
        const $targets = [];
        var $target: JQuery;
        for (let i = 0; i < $dynamicFields.length; i++) {
            const $dynamicField = $($dynamicFields[i] as any);
            const target = $dynamicField.attr(dynamicElementFieldTargetAttribute);

            if (!target)
                continue;

            $target = $($root.find(target)[0] as any);

            var guid = $target.attr(dynamicElementIdAttribute);

            if (!guid) {
                guid = this.createGuid();
                $target.attr(dynamicElementIdAttribute, guid);
            }

            $dynamicField.attr(dynamicElementRefAttribute, guid);

            if (isAlreadySetted($target))
                continue;

            $target.on(inputEventName, e => {
                const $this = $(e.currentTarget as any);
                onValueChange($this);
            });
        }

        for (let i = 0; i < $targets.length; i++) {
            $target = $($targets[i] as any);
            $target.trigger(inputEventName);
        }

        function isAlreadySetted($t: JQuery) {
            for (let j = 0; j < $targets.length; j++) {
                const $e = $($targets[j] as any);
                if ($e[0] === (($t as any)[0] as Element))
                    return true;
            }
            $targets.push($t);
            return false;
        }

        function onValueChange($input: JQuery) {
            const g = $input.attr(dynamicElementIdAttribute);
            if (!g)
                throw "Dynamic Field : Aucun GUID n'est associé au input.";
            const selectedVal = $input.val() as string;
            const $df = $root.find('[' + dynamicElementRefAttribute + "='" + g + "']");

            for (let ii = 0; ii < $df.length; ii++) {
                const $e = $($df[ii] as any);
                const values = ($e.attr(dynamicElementFieldValueAttribute) || '').split(' || ');

                if (containsValue(selectedVal, values))
                    $e.show();
                else
                    $e.hide();
            }

            function containsValue(searchedValue: string, valueCollection?: Array<string>) {
                if (!searchedValue)
                    return false;
                valueCollection = valueCollection || [];
                for (let iii = 0; iii < valueCollection.length; iii++) {
                    const v = valueCollection[iii];
                    if (v === searchedValue)
                        return true;
                }
                return false;
            }
        }
    }

    ensureCustomDataIsValid(data?: common.IPostCustomData) {
        data = data || {};

        data.stringValues = data.stringValues || {};
        data.guidValues = data.guidValues || {};
        data.floatValues = data.floatValues || {};
        data.intValues = data.intValues || {};

        return data;
    }

    insertNavContextHiddenField(formName: string, navContextId: string) {
        const value = navContextId || '';
        return this.insertHiddenField(formName, "navContext", value, true);
    }

    insertConcurrencySumCheckHiddenField(formName: string, sumCheck: string) {
        const value = sumCheck || '';
        return this.insertHiddenField(formName, "ConcurrencySumCheck", value, true);
    }

    insertHiddenField(formName: string, fieldName: string, fieldValue?: string, updateValueIfExists?: boolean) {
        updateValueIfExists = updateValueIfExists === true;
        fieldValue = fieldValue || ''

        if (!formName || !fieldName)
            return false;

        const form = $("form[name='" + formName + "']");

        if (!form)
            return false;

        const existingField = form.find("input[name='" + fieldName + "']");

        if (existingField.length) {
            if (updateValueIfExists)
                existingField.first().val(fieldValue);
            return updateValueIfExists;
        }

        form.append('<input type="hidden" name="' + fieldName + '" value="' + fieldValue + '" />')

        return true;
    }
    replaceLineBreakByBrTag(value: string) {
        return (value || '').replace(/\n/g, "<br />");
    }
    replaceBrTagByLineBreak(value: string) {
        return (value || '').replace(/<br \/>/g, "\n");
    }
    /** Formats disponibles : "N" (numerique), vide (avec les tirets)  */
    createGuid(format?: string) {
        const del = format === 'N' ? '' : '-';
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        const newGuid = s4() + s4() + del + s4() + del + s4() + del + s4() + del + s4() + s4() + s4();
        return newGuid;
    }
    /** Si 'where' n'est pas defini, alors 'any()' retournera TRUE si au moins un element est defini. */
    any(coll: any[], where: (x: any) => boolean) {
        coll = coll ?? [];
        where = where ?? (x => !!x);
        for (let i = 0; i < coll.length; i++) {
            const x = coll[i];
            if (where(x))
                return true;
        }
        return false;
    }
    all(coll: any[], where: (x: any) => boolean) {
        coll = coll ?? [];
        where = where ?? (x => !!x);
        for (let i = 0; i < coll.length; i++) {
            const x = coll[i];
            if (!where(x))
                return false;
        }
        return true;
    }

    /** supportEmptyValue: permet de copier du vide (default=TRUE), alertUserIfNotSupported: lancera une alert avec un message (default=FALSE), notSupportedMessage: message sur mesure (default=NULL) */
    copyToClipboard(text: string, supportEmptyValue?: boolean, alertUserIfNotSupported?: boolean, notSupportedMessage?: string) {
        text = (text || '').trim();
        supportEmptyValue = supportEmptyValue == true;//default=TRUE
        alertUserIfNotSupported = alertUserIfNotSupported !== false;//default=FALSE
        if (!text && !supportEmptyValue)
            return;
        if (!window.navigator || !window.navigator.clipboard || !window.navigator.clipboard.writeText) {
            if (alertUserIfNotSupported)
                alert(notSupportedMessage || "Désolé, la copie dans le presse-papier n'est pas supportée sur le navigateur actuel.");
            return;
        }
        //== https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
        window.navigator.clipboard.writeText(text);
        return this;
    }

    elementExists(target: string) {
        return target ? $(target).length > 0 : false;
    }

    //initializeNavigation(panelTarget: string, menuTarget: string, config?: { }) {
    //    config = (config || {}) as any;
    //    if (!config["panel"])
    //        config["panel"] = firstElementOrNull(panelTarget);
    //    if (!config["menu"])
    //        config["menu"] = firstElementOrNull(menuTarget);
    //    if (!config["padding"])
    //        config["padding"] = 250;
    //    if (!config["tolerance"])
    //        config["tolerance"] = 70;
    //    var instance = new SlideOut(config);
    //    return instance;
    //    function firstElementOrNull(t:string) : Element {
    //        var $e = $(t);
    //        return $e.length ? $e[0] : null;
    //    }
    //}

    serializeBag(bag: {}) {
        if (!bag) return null;
        const r = JSON.stringify(bag);
        return r;
    }

    disabledHotEditableButtonsByConfigurations(configurations: common.IHotFormDisabledButtonByDefaultFieldConfig[], formManager: HotEditableFormManager ) {
        for (let i = 0; i < (configurations || []).length; i++) {
            const c = configurations[i] || {} as common.IHotFormDisabledButtonByDefaultFieldConfig;
            const names = c.buttonNames || [];
            if (!!c.buttonName)
                names.push(c.buttonName);
            const buttons = [] as HotEditableButtonComponent[];
            var buttonNames = '';
            for (let j = 0; j < names.length; j++) {
                const name = names[j];
                const button = name ? formManager.getButtonByName(name) : null;
                if (!button) continue;
                if (!!buttonNames)
                    buttonNames += "|";
                buttonNames += name;
                buttons.push(button);
            }
            if (!buttons.length) continue;
            const fields = c.fields || [];
            if (c.field)
                    fields.push(c.field);
            if (!fields.length) throw "Référence(s) invalide(s) (buttonNames='" + buttonNames + "').";
            const results = [] as boolean[];
            for (let j = 0; j < fields.length; j++) { 
                const ref = fields[j];
                if (!ref.name) throw "La référence est mal configurée (buttonNames='" + buttonNames + "', fieldRef.name='" + ref.name + "').";
                if (!ref.condition) throw "La référence a une condition NULL (buttonNames='" + buttonNames + "', fieldRef.name='" + ref.name + "').";
                const field = formManager.getFieldByName(ref.name);
                if (field) {
                    const value = field.getTextualValue();
                    const result = ref.condition((value || '').trim(), value, field.fieldType);
                    results.push(result);
                }
            }
            var clauseIsAnd = c.fieldsConditionalClause === common.ConditionalClauses.and;
            var result = clauseIsAnd
                ? this.all(results, x => x)
                : this.any(results, x => x);
            
            //var result = clauseIsAnd;
            // for (let j = 0; j < results.length; j++) {
            //     const r = results[j];
            //     if (result === null)
            //         result = r;
            //     else
            //         result = clauseIsAnd ? result && r : result || r;
            // }
            for (let j = 0; j < buttons.length; j++) {
                const button = buttons[j];
                if (button.disabled !== result)
                    button.isDisabled(result);
            }
        }
    }
    extractFormData(formTarget: string) {
        return !!formTarget ? new FormData($(formTarget)[0] as HTMLFormElement) : new FormData();
    }
}

export = new Utilities();